/** @format */

import Vue from 'vue'
import Filters from './filter'

/** -------------- Vue global config ------------------- */

Vue.config.productionTip = false

Vue.prototype.baseURL = process.env.VUE_APP_API_BASE_URL;

import {
  apiBaseUrl
} from './helper/env'
Vue.prototype.apiBaseUrl = apiBaseUrl
Vue.prototype.baseURL = apiBaseUrl
Vue.prototype.baseUrl = apiBaseUrl

/** -------------- Vue global variable ----------------- */

import axios from "axios";
Vue.prototype.$axios = axios;

import {
  Confirm,
  Alert,
  Toast,
  Notify,
  Loading
} from 'vue-ydui/dist/lib.rem/dialog';
Vue.prototype.$dialog = {
  confirm: Confirm,
  alert: Alert,
  toast: Toast,
  notify: Notify,
  loading: Loading,
};

import {
  fetch,
  post,
  postUrl,
  postImg
} from "./helper/http.js";
Vue.prototype.$fetch = fetch;
Vue.prototype.$post = post;
Vue.prototype.$postUrl = postUrl;
Vue.prototype.$postImg = postImg;

import util from './helper/util';
Vue.prototype.$geturlpara = util.getUrlKey
Vue.prototype.$getUrlKey = util.getUrlKey
Vue.prototype.$testUA = util.testUA
Vue.prototype.$convert2Date = util.convert2Date
Vue.prototype.$delay = util.delay


import validators from './helper/validators'
Vue.prototype.isMobile = validators.isMobile
Vue.prototype.validNull = validators.validNull
Vue.prototype.isEmail = validators.isEmail
Vue.prototype.isIdNo = validators.isIdNo
Vue.prototype.isNum = validators.isNum

import doc from './helper/document'
Vue.prototype.getHeight = doc.getHeight
Vue.prototype.removeHtml = doc.removeHtml




for (let key in Filters) {
  Vue.filter(key, Filters[key])
}

/** -------------- Vue global components ----------------- */

import {
  Slider,
  SliderItem
} from 'vue-ydui/dist/lib.rem/slider';

Vue.component(Slider.name, Slider);
Vue.component(SliderItem.name, SliderItem);

import YDUI from 'vue-ydui';
Vue.use(YDUI);

import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)

import {
  DateTime
} from 'vue-ydui/dist/lib.rem/datetime';
Vue.component(DateTime.name, DateTime);

import {
  InfiniteScroll
} from "mint-ui";
Vue.use(InfiniteScroll);

import vuelidate from 'vuelidate';
Vue.use(vuelidate);
